module.exports = __webpack_public_path__ + "92ccf0e0f1a4ba8dc628f673a3afcf5b.png";